/*
 * Cart drawer "Complete your look" carousel arrows.
 * The recommendations markup is injected via innerHTML (see product-recommendations.js),
 * so behaviour is wired with a single delegated listener on the document.
 */
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest('.fv-cart-cyl__nav button');
  if (!button) return;

  const carousel = button.closest('.fv-cart-cyl');
  const track = carousel?.querySelector('.fv-cart-cyl__track');
  if (!track) return;

  const direction = button.dataset.dir === 'prev' ? -1 : 1;
  track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
});

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const tab = target?.closest('.fv-cart-tab');
  if (!tab) return;

  const tablist = tab.closest('.fv-cart-tabs');
  const drawerInner = tab.closest('.cart-drawer__inner');
  const targetPanel = tab.dataset.tabTarget;
  if (!tablist || !drawerInner || !targetPanel) return;

  const tabs = tablist.querySelectorAll('.fv-cart-tab');
  tabs.forEach((button) => {
    const isActive = button === tab;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  const panels = drawerInner.querySelectorAll('.fv-cart-panel');
  panels.forEach((panel) => {
    const isActive = panel.id === `fv-cart-panel-${targetPanel}`;
    panel.classList.toggle('is-active', isActive);
    panel.toggleAttribute('hidden', !isActive);
  });
});
